import { DASHBOARD_SET_GROUP_SELECTOR } from './constants'

export function setGroupSelector(groupId) {
    return (dispatch) =>{
      dispatch({
        type: DASHBOARD_SET_GROUP_SELECTOR,
        data: groupId 
      })
  };
}

export function reducer(state, action) {
  if (action.type === DASHBOARD_SET_GROUP_SELECTOR) {
    return {  
      ...state,  
      groupSelected: action.data 
    }
  } else {
    return state
  }
}